import {Component, NgModule, OnInit, AfterViewInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements  OnInit {
  title: any;

  constructor(private titleService: Title) {
    // PeopleSearchTSIC
    this.titleService.setTitle('ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า');
  }

  ngOnInit() {
    
  }
}
